import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.gray8};
  padding: 1.5rem;
`;

export const ExternalLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.darkBlue2};
  font-size: 1rem;
  &:visited {
    color: ${({ theme }) => theme.colors.darkBlue2};
  }
`;

export const CustomTable = styled.div`
  margin-top: 1rem;
  table {
    width: 100%;
    border-collapse: collapse;
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-size: 1rem;
    border: 0.188rem solid ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.grayDark4};
    text-align: left;

    td {
      padding: 0 0.5rem;
      height: 2.5rem;
    }

    thead td {
      background-color: #a7d4ff;
    }

    thead td:hover {
      background-color: #dce9ff;
    }

    tbody tr:nth-child(odd) {
      background-color: #ecf2f6;
    }

    tbody tr:nth-child(even) {
      background-color: ${({ theme }) => theme.colors.white};
    }

    tbody tr:hover {
      background-color: #efefef;
    }
  }
`;
